import * as React from "react";
import {MouseEvent} from "react";
import ModalComponent, {ModalSizes} from "../../../_widgets/modal/ModalComponent";
import {History} from "history";
import Style from "../../../_data/models/Style";
import {PrimaryModels} from "../../../_definitions/styleteq";
import ModalStyleContainer from "../containers/ModalStyleContainer";

type toggleLikeType = (e: MouseEvent<HTMLElement>, model: PrimaryModels) => void;

interface Props {
    model: PrimaryModels;
    history: History;
    toggleLike: toggleLikeType;
}

function getModalContent(model: PrimaryModels, toggleLike: toggleLikeType) {
    const toggleLikeWrapper = (e: MouseEvent<HTMLElement>) => {
        return toggleLike(e, model);
    };

    if (model instanceof Style)
        return <ModalStyleContainer style={model as Style} toggleLike={toggleLikeWrapper}/>
}

const ActivityFeedModalComponent = (props: Props) => {
    const {history, model, toggleLike} = props;

    return (
        <ModalComponent show={true} onExit={() => history.goBack()} size={ModalSizes.MEDIUMLARGE} className="newsfeed-modal">
            <div className="newsfeed-panel callout paddingless marginless borderless"
                 style={{maxWidth: '100%'}}>
                {getModalContent(model, toggleLike)}
            </div>
        </ModalComponent>
    );
};
export default ActivityFeedModalComponent;


// WEBPACK FOOTER //
// ./app/client/activityFeeds/modal/components/ActivityFeedModalComponent.tsx